"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _LinkedIn = _interopRequireDefault(require("@mui/icons-material/LinkedIn"));

var _Facebook = _interopRequireDefault(require("@mui/icons-material/Facebook"));

var _Twitter = _interopRequireDefault(require("@mui/icons-material/Twitter"));

var _YouTube = _interopRequireDefault(require("@mui/icons-material/YouTube"));

var _DesktopFooterItems = _interopRequireDefault(require("./DesktopFooterItems"));

var _MobileFooterItems = _interopRequireDefault(require("./MobileFooterItems"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledToolbar = (0, _styles.styled)(_material.Toolbar)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: 'transparent',
    paddingTop: '1rem',
    paddingBottom: '1rem'
  };
});
var StyledGrid = (0, _styles.styled)(_material.Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n"])));
var StyledLink = (0, _styles.styled)('a')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    border: '1px solid',
    borderColor: theme.palette.footerIcon.default,
    borderRadius: '20px',
    display: 'inline-flex',
    padding: '2px',
    fontSize: '1rem',
    color: theme.palette.footerIcon.default,
    width: '22px',
    height: '22px'
  };
});

var AttunedFooter = function AttunedFooter() {
  return /*#__PURE__*/_react.default.createElement(StyledToolbar, {
    id: "mmp-footer"
  }, /*#__PURE__*/_react.default.createElement(_DesktopFooterItems.default, null), /*#__PURE__*/_react.default.createElement(_MobileFooterItems.default, null), /*#__PURE__*/_react.default.createElement(StyledGrid, {
    container: true,
    spacing: 1.5
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    role: "link",
    "aria-label": "linkedin",
    target: "_blank",
    href: "https://www.linkedin.com/company/attunedai/",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_LinkedIn.default, {
    size: "small",
    fontSize: "1rem"
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    role: "link",
    "aria-label": "facebook",
    target: "_blank",
    href: "https://www.facebook.com/attunedai",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_Facebook.default, {
    size: "small",
    fontSize: "1rem"
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    role: "link",
    "aria-label": "twitter",
    target: "_blank",
    href: "https://twitter.com/attunedai",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_Twitter.default, {
    size: "small",
    fontSize: "1rem"
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(StyledLink, {
    role: "link",
    "aria-label": "youtube",
    target: "_blank",
    href: "https://www.youtube.com/channel/UCwaHUa4G_V5nEXYtlmVbRqw",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_YouTube.default, {
    size: "small",
    fontSize: "1rem"
  })))));
};

var _default = AttunedFooter;
exports.default = _default;